import classNames from "classnames"
import { Link } from "gatsby"
import React from "react"
import { button, primary, secondary, white_noshadow, white, blue, s, m, l, arrow, arrow_white, nav, border, back, corner, square, fill, text, active, gray } from "./button.module.scss"

interface Props {
  className?: string
  to?: string
  href?: string
  target?: string
  fill?: boolean
  color?: "primary" | "secondary" | "white" | "white_noshadow" | "border" | "text" | "nav" | "blue" | "arrow" | "arrow_white" | "gray"
  use?: "back"
  radii?: "corner" | "square"
  size?: "s" | "m" | "l"
  active?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  children: React.ReactNode
}

export default React.memo((props: Props) => {
  const { className, fill: fillValue, color, to, href, target, onClick, children, size, active: activeValue, use, radii } = props
  const classes = classNames(
    button,
    {
      [fill]: fillValue,
      [primary]: color === "primary",
      [secondary]: color === "secondary",
      [blue]: color === "blue",
      [gray]: color === "gray",
      [white]: color === "white",
      [white_noshadow]: color === "white_noshadow",
      [text]: color === "text",
      [arrow]: color === "arrow",
      [arrow_white]: color === "arrow_white",
      [nav]: color === "nav",
      [border]: color === "border",
      [s]: size === "s",
      [m]: size === "m",
      [l]: size === "l",
      [back]: use === "back",
      [corner]: radii === "corner",
      [square]: radii === "square",
      [active]: activeValue,
    },
    className
  )

  if (to) {
    return (
      <Link className={classes} to={to}>
        {children}
      </Link>
    )
  } else if (href) {
    return (
      <a
        className={classes}
        href={href}
        target={target}
        rel="noreferrer noopener"
      >
        {children}
      </a>
    )
  } else {
    return (
      <button className={classes} onClick={onClick}>
        {children}
      </button>
    )
  }
})
